// Layout组件的入口文件
import Layout from './Layout';

export default Layout;